/* eslint-disable */
import React, { useEffect, useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Link, useLocation } from "react-router-dom";
import { getSidebarData } from "../../core/json/siderbar_data";
import { useTranslation } from "react-i18next";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { useShopRoutes } from "../../hooks/useShopRoutes";
import { selectAccessibleStores } from "../../core/redux/store.slice";
import { getShopIdFromUrl } from "../../utils/routeUtils";
import { fetchActiveCompany } from "../../core/redux/company.slice";
import { useDispatch, useSelector } from "react-redux";

const fallbackImage = "/assets/img/users/user-00.png";

const Sidebar = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const route = useShopRoutes();
  const Location = useLocation();

  // Redux
  const user = useSelector((state) => state.auth.user);
  const { company } = useSelector((state) => state.company);

  useEffect(() => {
    if (!company) {
      dispatch(fetchActiveCompany());
    }
  }, [dispatch, company]);

  // Get company photos
 const companyPhotos = (company?.photos || []).filter(
  (p) =>
    !p.productId &&
    !p.userId &&
    !p.customerId &&
    !p.supplierId &&
    !p.shopId &&
    !p.groupId &&
    !p.makerId &&
    !p.modelId
);

const logoSrc =
  companyPhotos.find(
    (p) => p.isPrincipal && p.presignedUrl
  )?.presignedUrl ||
  companyPhotos.find(
    (p) => p.presignedUrl
  )?.presignedUrl ||
  fallbackImage;
  const accessibleStores = useSelector(selectAccessibleStores);

  const currentShopId = getShopIdFromUrl();

  const currentShop = accessibleStores.find(
    (s) => String(s.shopId) === String(currentShopId)
  );

  const isCanteen =
    currentShop?.type === "CANTEEN" ||
    currentShop?.isCanteen === true ||
    currentShop?.category === "CANTEEN";

  const sidebarData = getSidebarData(
    route,
    user,
    t,
    isCanteen
  );

  const [subOpen, setSubopen] = useState("");
  const [subsidebar, setSubsidebar] = useState("");
  const [toggle, SetToggle] = useState(false);

  const toggleSidebar = (title) => {
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };

  const { expandMenus } = useSelector(
    (state) => state.themeSetting.expandMenus
  );

  const dataLayout = useSelector(
    (state) => state.themeSetting.dataLayout
  );

  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };

  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };

  return (
    <div>
      <div
        className={`sidebar ${toggle ? "" : "active"
          } ${expandMenus || dataLayout === "layout-hovered"
            ? "expand-menu"
            : ""
          }`}
        id="sidebar"
        onMouseLeave={expandMenu}
        onMouseOver={expandMenuOpen}
      >
        {/* Logo */}
        <div className="sidebar-logo">
          <Link to="#" className="logo logo-normal">
            <img
              src={logoSrc}
              alt="company logo"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = fallbackImage;
              }}
            />
          </Link>
        </div>

        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                {sidebarData?.map((mainLabel, index) => (
                  <li
                    className="submenu-open"
                    key={index}
                  >
                    <h6 className="submenu-hdr">
                      {mainLabel?.label}
                    </h6>

                    <ul>
                      {mainLabel?.submenuItems?.map(
                        (title, i) => {
                          let link_array = [];

                          title?.submenuItems?.map(
                            (link) => {
                              link_array.push(link?.link);

                              if (link?.submenu) {
                                link?.submenuItems?.map(
                                  (item) => {
                                    link_array.push(
                                      item?.link
                                    );
                                  }
                                );
                              }

                              return link_array;
                            }
                          );

                          title.links = link_array;

                          return (
                            <React.Fragment key={i}>
                              <li
                                className={`submenu ${!title?.submenu &&
                                    Location.pathname ===
                                    title?.link
                                    ? "custom-active-hassubroute-false"
                                    : ""
                                  }`}
                              >
                                <Link
                                  to={
                                    title?.submenu
                                      ? "#"
                                      : title?.link
                                  }
                                  onClick={() =>
                                    toggleSidebar(
                                      title?.label
                                    )
                                  }
                                  className={`${subOpen ===
                                      title?.label
                                      ? "subdrop"
                                      : ""
                                    } ${(title?.submenu &&
                                      title?.links &&
                                      title.links.includes(
                                        Location.pathname
                                      )) ||
                                      (!title?.submenu &&
                                        Location.pathname ===
                                        title?.link)
                                      ? "active"
                                      : ""
                                    }`}
                                >
                                  <i
                                    className={`ti ti-${title.icon} me-2`}
                                  />

                                  <span className="custom-active-span">
                                    {t(title?.label)}
                                  </span>

                                  {title?.submenu && (
                                    <span className="menu-arrow" />
                                  )}
                                </Link>

                                <ul
                                  style={{
                                    display:
                                      subOpen ===
                                        title?.label
                                        ? "block"
                                        : "none",
                                  }}
                                >
                                  {title?.submenuItems?.map(
                                    (
                                      item,
                                      titleIndex
                                    ) => (
                                      <li
                                        className="submenu submenu-two"
                                        key={titleIndex}
                                      >
                                        <Link
                                          to={item?.link}
                                          className={`${item?.submenuItems
                                              ?.map(
                                                (link) =>
                                                  link.link
                                              )
                                              .includes(
                                                Location.pathname
                                              ) ||
                                              item?.link ===
                                              Location.pathname
                                              ? "active"
                                              : ""
                                            } ${subsidebar ===
                                              item?.label
                                              ? "subdrop"
                                              : ""
                                            }`}
                                          onClick={() =>
                                            toggleSubsidebar(
                                              item?.label
                                            )
                                          }
                                        >
                                          {item?.label}

                                          {item?.submenu && (
                                            <span className="menu-arrow inside-submenu" />
                                          )}
                                        </Link>

                                        <ul
                                          style={{
                                            display:
                                              subsidebar ===
                                                item?.label
                                                ? "block"
                                                : "none",
                                          }}
                                        >
                                          {item?.submenuItems?.map(
                                            (
                                              items,
                                              subIndex
                                            ) => (
                                              <li
                                                key={
                                                  subIndex
                                                }
                                              >
                                                <Link
                                                  to={
                                                    items?.link
                                                  }
                                                  className={`${subsidebar ===
                                                      items?.label
                                                      ? "submenu-two subdrop"
                                                      : "submenu-two"
                                                    } ${items?.submenuItems
                                                      ?.map(
                                                        (
                                                          link
                                                        ) =>
                                                          link.link
                                                      )
                                                      .includes(
                                                        Location.pathname
                                                      ) ||
                                                      items?.link ===
                                                      Location.pathname
                                                      ? "active"
                                                      : ""
                                                    }`}
                                                >
                                                  {
                                                    items?.label
                                                  }
                                                </Link>
                                              </li>
                                            )
                                          )}
                                        </ul>
                                      </li>
                                    )
                                  )}
                                </ul>
                              </li>
                            </React.Fragment>
                          );
                        }
                      )}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </div>
  );
};

export default Sidebar;